// GENERATED by packages/gen1-data/src/generate/index.ts from pokered.sym / pokeblue.sym. Do not edit.
// Every address here is identical in Red and Blue (checked at generation time).

export const SYM = {
  sSpriteBuffer0: { bank: 0x00, addr: 0xa000 },
  sSpriteBuffer1: { bank: 0x00, addr: 0xa188 },
  sSpriteBuffer2: { bank: 0x00, addr: 0xa310 },
  sHallOfFame: { bank: 0x00, addr: 0xa598 },
  sGameData: { bank: 0x01, addr: 0xa598 },
  sPlayerName: { bank: 0x01, addr: 0xa598 },
  sMainData: { bank: 0x01, addr: 0xa5a3 },
  sSpriteData: { bank: 0x01, addr: 0xad2c },
  sPartyData: { bank: 0x01, addr: 0xaf2c },
  sCurBoxData: { bank: 0x01, addr: 0xb0c0 },
  sTileAnimations: { bank: 0x01, addr: 0xb522 },
  sGameDataEnd: { bank: 0x01, addr: 0xb523 },
  sMainDataCheckSum: { bank: 0x01, addr: 0xb523 },
  sBox1: { bank: 0x02, addr: 0xa000 },
  sBox2: { bank: 0x02, addr: 0xa462 },
  sBox3: { bank: 0x02, addr: 0xa8c4 },
  sBox4: { bank: 0x02, addr: 0xad26 },
  sBox5: { bank: 0x02, addr: 0xb188 },
  sBox6: { bank: 0x02, addr: 0xb5ea },
  sBank2AllBoxesChecksum: { bank: 0x02, addr: 0xba4c },
  sBank2IndividualBoxChecksums: { bank: 0x02, addr: 0xba4d },
  sBox7: { bank: 0x03, addr: 0xa000 },
  sBox8: { bank: 0x03, addr: 0xa462 },
  sBox9: { bank: 0x03, addr: 0xa8c4 },
  sBox10: { bank: 0x03, addr: 0xad26 },
  sBox11: { bank: 0x03, addr: 0xb188 },
  sBox12: { bank: 0x03, addr: 0xb5ea },
  sBank3AllBoxesChecksum: { bank: 0x03, addr: 0xba4c },
  sBank3IndividualBoxChecksums: { bank: 0x03, addr: 0xba4d },
  wPlayerName: { bank: 0x00, addr: 0xd158 },
  wPartyCount: { bank: 0x00, addr: 0xd163 },
  wPartyDataStart: { bank: 0x00, addr: 0xd163 },
  wPartySpecies: { bank: 0x00, addr: 0xd164 },
  wPartyMons: { bank: 0x00, addr: 0xd16b },
  wPartyMonOT: { bank: 0x00, addr: 0xd273 },
  wPartyMonNicks: { bank: 0x00, addr: 0xd2b5 },
  wMainDataStart: { bank: 0x00, addr: 0xd2f7 },
  wPokedexOwned: { bank: 0x00, addr: 0xd2f7 },
  wPokedexSeen: { bank: 0x00, addr: 0xd30a },
  wNumBagItems: { bank: 0x00, addr: 0xd31d },
  wBagItems: { bank: 0x00, addr: 0xd31e },
  wPlayerMoney: { bank: 0x00, addr: 0xd347 },
  wRivalName: { bank: 0x00, addr: 0xd34a },
  wOptions: { bank: 0x00, addr: 0xd355 },
  wObtainedBadges: { bank: 0x00, addr: 0xd356 },
  wPlayerID: { bank: 0x00, addr: 0xd359 },
  wCurMap: { bank: 0x00, addr: 0xd35e },
  wNumBoxItems: { bank: 0x00, addr: 0xd53a },
  wBoxItems: { bank: 0x00, addr: 0xd53b },
  wCurrentBoxNum: { bank: 0x00, addr: 0xd5a0 },
  wNumHoFTeams: { bank: 0x00, addr: 0xd5a2 },
  wPlayerCoins: { bank: 0x00, addr: 0xd5a4 },
  wGameProgressFlags: { bank: 0x00, addr: 0xd5f0 },
  wEventFlags: { bank: 0x00, addr: 0xd747 },
  wPlayTimeHours: { bank: 0x00, addr: 0xda41 },
  wPlayTimeMaxed: { bank: 0x00, addr: 0xda42 },
  wPlayTimeMinutes: { bank: 0x00, addr: 0xda43 },
  wPlayTimeSeconds: { bank: 0x00, addr: 0xda44 },
  wPlayTimeFrames: { bank: 0x00, addr: 0xda45 },
  wDayCareInUse: { bank: 0x00, addr: 0xda48 },
  wDayCareMonName: { bank: 0x00, addr: 0xda49 },
  wDayCareMonOT: { bank: 0x00, addr: 0xda54 },
  wDayCareMon: { bank: 0x00, addr: 0xda5f },
  wMainDataEnd: { bank: 0x00, addr: 0xda80 },
  wBoxDataStart: { bank: 0x00, addr: 0xda80 },
  wBoxCount: { bank: 0x00, addr: 0xda80 },
  wBoxSpecies: { bank: 0x00, addr: 0xda81 },
  wBoxMons: { bank: 0x00, addr: 0xda96 },
  wBoxMonOT: { bank: 0x00, addr: 0xdd2a },
  wBoxMonNicks: { bank: 0x00, addr: 0xde06 },
  wBoxDataEnd: { bank: 0x00, addr: 0xdee2 },
  wSpriteDataStart: { bank: 0x00, addr: 0xc100 },
  wSpriteDataEnd: { bank: 0x00, addr: 0xc300 },
  wIsInBattle: { bank: 0x00, addr: 0xd057 },
  wBattleType: { bank: 0x00, addr: 0xd05a },
  wCurOpponent: { bank: 0x00, addr: 0xd059 },
  wTrainerNo: { bank: 0x00, addr: 0xd05d },
  wTrainerClass: { bank: 0x00, addr: 0xd031 },
  wAmountMoneyWon: { bank: 0x00, addr: 0xd079 },
  wSaveFileStatus: { bank: 0x00, addr: 0xd088 },
  wCurEnemyLevel: { bank: 0x00, addr: 0xd127 },
  wLinkState: { bank: 0x00, addr: 0xd12b },
  wEnemyMonSpecies: { bank: 0x00, addr: 0xcfe5 },
  wEnemyMonLevel: { bank: 0x00, addr: 0xcff3 },
  wEnemyMonSpecies2: { bank: 0x00, addr: 0xcfd8 },
  wCurPartySpecies: { bank: 0x00, addr: 0xcf91 },
  wCurItem: { bank: 0x00, addr: 0xcf91 },
  wItemQuantity: { bank: 0x00, addr: 0xcf96 },
  wWalkCounter: { bank: 0x00, addr: 0xcfc5 },
  wSimulatedJoypadStatesIndex: { bank: 0x00, addr: 0xcd38 },
  wJoyIgnore: { bank: 0x00, addr: 0xcd6b },
  hTileAnimations: { bank: 0x00, addr: 0xffd7 },
  BaseStats: { bank: 0x0e, addr: 0x43de },
  MewBaseStats: { bank: 0x01, addr: 0x425b },
  PokedexOrder: { bank: 0x10, addr: 0x5024 },
  MonsterNames: { bank: 0x07, addr: 0x421e },
  EvosMovesPointerTable: { bank: 0x0e, addr: 0x705c },
  GrowthRateTable: { bank: 0x16, addr: 0x501d },
  Moves: { bank: 0x0e, addr: 0x4000 },
  MoveNames: { bank: 0x2c, addr: 0x4000 },
  TechnicalMachines: { bank: 0x04, addr: 0x7773 },
  ItemPrices: { bank: 0x01, addr: 0x4608 },
  ItemNames: { bank: 0x01, addr: 0x472b },
  TechnicalMachinePrices: { bank: 0x1e, addr: 0x7fa7 },
  TrainerPicAndMoneyPointers: { bank: 0x0e, addr: 0x5914 },
  TrainerDataPointers: { bank: 0x0e, addr: 0x5d3b },
  TrainerNames: { bank: 0x0e, addr: 0x59ff },
  WildDataPointers: { bank: 0x03, addr: 0x4eeb },
  SuperRodData: { bank: 0x03, addr: 0x6919 },
  GoodRodMons: { bank: 0x03, addr: 0x627f },
  TradeMons: { bank: 0x1c, addr: 0x5b7b },
  PrizeMonLevelDictionary: { bank: 0x14, addr: 0x698a },
  CalcCheckSum: { bank: 0x1c, addr: 0x7856 },
  CalcStat: { bank: 0x00, addr: 0x394a },
  CalcExperience: { bank: 0x16, addr: 0x4f6a },
  CalcLevelFromExperience: { bank: 0x16, addr: 0x4f43 },
  GainExperience: { bank: 0x15, addr: 0x524f },
  TrainerBattleVictory: { bank: 0x0f, addr: 0x4696 },
  PayDayEffect_: { bank: 0x0b, addr: 0x7eb8 },
  AddItemToInventory_: { bank: 0x03, addr: 0x4e04 },
  RemoveItemFromInventory_: { bank: 0x03, addr: 0x4e74 },
  PlayerPCDeposit: { bank: 0x01, addr: 0x7995 },
  PlayerPCWithdraw: { bank: 0x01, addr: 0x7a12 },
  DisplayPokemartDialogue_: { bank: 0x01, addr: 0x6c20 },
  SubtractAmountPaidFromMoney_: { bank: 0x01, addr: 0x6b21 },
  InitWildBattle: { bank: 0x0f, addr: 0x6f8b },
  LoadEnemyMonData: { bank: 0x0f, addr: 0x6b01 },
  ItemUseBall: { bank: 0x03, addr: 0x5687 },
  _AddPartyMon: { bank: 0x03, addr: 0x72e5 },
  _GivePokemon: { bank: 0x13, addr: 0x7da5 },
  SendNewMonToBox: { bank: 0x03, addr: 0x67a4 },
  EvolveMon: { bank: 0x1e, addr: 0x7de9 },
  BillsPCRelease: { bank: 0x08, addr: 0x5673 },
  InGameTrade_DoTrade: { bank: 0x1c, addr: 0x5c07 },
  ResetStatusAndHalveMoneyOnBlackout: { bank: 0x01, addr: 0x40b0 },
  SoftReset: { bank: 0x00, addr: 0x1f49 },
  JoypadOverworld: { bank: 0x00, addr: 0x0f4d },
  SaveGameData: { bank: 0x1c, addr: 0x7848 },
} as const;

/** Symbols whose address differs between versions. Never use these as hooks. */
export const VERSION_SYMBOLS = {
  RED: {
    HiddenItems: { bank: 0x1d, addr: 0x6688 },
  },
  BLUE: {
    HiddenItems: { bank: 0x1d, addr: 0x6689 },
  },
} as const;

/** §11.7.1 hooks plus JoypadOverworld and SaveGameData, in manifest order. */
export const ROM_HOOKS: readonly { name: string; bank: number; addr: number }[] = [
  { name: "TrainerBattleVictory", bank: 0x0f, addr: 0x4696 },
  { name: "PayDayEffect_", bank: 0x0b, addr: 0x7eb8 },
  { name: "AddItemToInventory_", bank: 0x03, addr: 0x4e04 },
  { name: "RemoveItemFromInventory_", bank: 0x03, addr: 0x4e74 },
  { name: "PlayerPCDeposit", bank: 0x01, addr: 0x7995 },
  { name: "PlayerPCWithdraw", bank: 0x01, addr: 0x7a12 },
  { name: "DisplayPokemartDialogue_", bank: 0x01, addr: 0x6c20 },
  { name: "SubtractAmountPaidFromMoney_", bank: 0x01, addr: 0x6b21 },
  { name: "InitWildBattle", bank: 0x0f, addr: 0x6f8b },
  { name: "LoadEnemyMonData", bank: 0x0f, addr: 0x6b01 },
  { name: "ItemUseBall", bank: 0x03, addr: 0x5687 },
  { name: "_AddPartyMon", bank: 0x03, addr: 0x72e5 },
  { name: "_GivePokemon", bank: 0x13, addr: 0x7da5 },
  { name: "SendNewMonToBox", bank: 0x03, addr: 0x67a4 },
  { name: "EvolveMon", bank: 0x1e, addr: 0x7de9 },
  { name: "BillsPCRelease", bank: 0x08, addr: 0x5673 },
  { name: "InGameTrade_DoTrade", bank: 0x1c, addr: 0x5c07 },
  { name: "ResetStatusAndHalveMoneyOnBlackout", bank: 0x01, addr: 0x40b0 },
  { name: "SoftReset", bank: 0x00, addr: 0x1f49 },
  { name: "JoypadOverworld", bank: 0x00, addr: 0x0f4d },
  { name: "SaveGameData", bank: 0x1c, addr: 0x7848 },
];
